import './app.css';
import './palettes.generated.css'; // full M3 scheme per palette (after app.css so it wins)
import { mount } from 'svelte';
import App from './App.svelte';

const app = mount(App, { target: document.getElementById('app') });
export default app;
